import styled from "@emotion/styled";
import { MDSTextField } from "@/mds/components/forms/text-field";

export const StyledWrapper = styled.div`
  padding-block: ${({ theme }) => theme.spacing[1]};
  background-color: ${({ theme }) => theme.colors.background.menu.default};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const StyledSearchInput = styled(MDSTextField)`
  border: unset;
  background-color: transparent;
`;
